<template>
  <div class="filter-infos" v-if="filterGroups && filterGroups.length > 0">
    <FilterInfo v-for="filterGroup in filterGroups"
                :key="filterGroup.key"
                :filter-group="filterGroup"
                @remove-tag="$emit('remove-tag', $event)" />
  </div>
</template>

<script>
import FilterInfo from './FilterInfo.vue';

export default {
  name: 'FilterInfos',

  components: { FilterInfo },

  props: {
    filterGroups: { type: Array, required: true }
  },

  emits: ['remove-tag']
};
</script>

<style lang="scss" scoped>
.filter-infos {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 16px;
  border: 1px solid var(--bs-border-color);
  border-radius: var(--radius-md);
}
</style>
